export default __webpack_public_path__ + "static/media/1110.0396644c.png";